import { captureBioToken } from './bioLinkToken';

// Imported first in src/index.js, so it runs before the store, the router,
// GTM, the Facebook pixel and PostHog get a chance to read the URL.
if (typeof window !== 'undefined') captureBioToken(window);
